import React from 'react'
import { Box, Typography } from '@mui/material'
import { useIsMobile } from '@/hooks/Responsive'

export default function NotFound() {
  const { isMobile } = useIsMobile()
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        minHeight: 'calc(100dvh - 413px)',
        pt: 10,
      }}
    >
      {/* 동그란 아이콘 배경 */}
      <Box
        sx={{
          width: '64px',
          height: '64px',
          borderRadius: '50%',
          bgcolor: 'grey.100',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 4,
          flexShrink: 0,
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="4" height="25" viewBox="0 0 4 25" fill="none">
          <path d="M2 21C3.10457 21 4 21.8954 4 23C4 24.1046 3.10457 25 2 25C0.895431 25 0 24.1046 0 23C0 21.8954 0.895431 21 2 21Z" fill="#8A949E"/>
          <path d="M2 0C3.10457 0 4 0.895431 4 2V16C4 17.1046 3.10457 18 2 18C0.895431 18 0 17.1046 0 16V2C0 0.895431 0.895431 0 2 0Z" fill="#8A949E"/>
        </svg>
      </Box>

      <Typography variant={isMobile ? 'subtitle2' : 'subtitle1'} fontWeight={500} sx={{ mb: 1.5 }}>
        요청하신 페이지를 찾을 수 없습니다.
      </Typography>

      <Typography color="text.secondary">
        입력한 주소가 잘못되었거나, 사용이 일시중단되어 요청하신 페이지를 찾을 수 없습니다.<br />
        서비스 이용에 불편을 드려 죄송합니다.
      </Typography>
    </Box>
  )
}
